// TankView shared HTTP helper. See TSP-142.
// Attaches the JWT, JSON-encodes bodies, surfaces server messages on error,
// and forces a logout on 401 so the user lands on /login instead of seeing
// silent failures.

import { getToken, logout } from "../auth";

const API_URL = window.location.origin;

export async function apiCall(path, options = {}) {
  const token = getToken();
  const isFormData = options.body instanceof FormData;
  const headers = {
    Authorization: `Bearer ${token}`,
    ...(isFormData ? {} : { "Content-Type": "application/json" }),
    ...options.headers,
  };

  const res = await fetch(`${API_URL}${path}`, { ...options, headers });

  if (res.status === 401) {
    logout();
    throw new Error("Session expired");
  }

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || `API error ${res.status}`);
  }

  if (res.status === 204) return null;
  return res.json();
}

// Build a same-origin URL with the JWT attached as a query param. Useful for
// img/iframe src where Authorization headers can't be set. The backend must
// honor `?t=<token>` as a fallback (the upload service already does).
export function authSrc(path) {
  const token = getToken();
  const sep = path.includes("?") ? "&" : "?";
  return `${API_URL}${path}${sep}t=${encodeURIComponent(token || "")}`;
}

export default apiCall;
